// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".watch-now-button button.basic-button:hover{background-color:#5a6773}.watch-now-button--large ion-button{height:48px}.watch-now-button--slim ion-button{height:36px}.watch-now-button button.basic-button.secondary{font-weight:500}.watch-now-button .basic-button__content{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
